import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setAppBarTitle } from '../redux/app-bar/actions';

const useAppBarTitle = (title?: string) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setAppBarTitle(title ?? ''));
    }, [dispatch, title]);
};

export default useAppBarTitle;
